/*
 * @Author: your name
 * @Date: 2021-11-17 14:42:35
 * @LastEditTime: 2021-11-17 14:42:35
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/utils/filtrs.js
 */
import moment from 'moment';

const timeHandleFilter = (time) => {
  moment(time).format('YYYY/MM/DD HH:mm'); // 重置时间格式
};

export {
  // eslint-disable-next-line import/prefer-default-export
  timeHandleFilter,
};
